import * as React from 'react';
import propz from 'propz';
import moment from 'moment';

import { getEventNameWithLink } from 'Src/helpers/cell/cell';
import { AppUser } from 'Src/views/App/App';
import { SchoolEvent } from 'Src/models/event';

interface Props {
  leagueEvents: SchoolEvent[];
  user: AppUser;
}

export function SchoolLeagueEventsSummary(props: Props) {
  const { leagueEvents, user } = props;
  const options = {
    user
  };

  const rows = leagueEvents.map((event, index) => {
    const eventName = getEventNameWithLink(event, options);
    const startTimeValue = propz.get(event, ['startTime'], '');
    const startTime = startTimeValue ? moment(startTimeValue).format('DD MMM YYYY') : '—';
    const eventSport = propz.get(event, ['sport', 'name'], '');

    return (
      <tr key={`event_summary_${index}`}>
        {eventName}
        <td>{eventSport || '—'}</td>
        <td>{startTime}</td>
      </tr>
    );
  });

  const emptyRow = (
    <tr key={'events_empty_row'}>
      <td colSpan={3}>No events have been added to this league.</td>
    </tr>
  );

  return (
    <table className="leagueEventsSummary">
      <thead>
        <tr>
          <th>Event</th>
          <th>Sport</th>
          <th>Start date</th>
        </tr>
      </thead>
      <tbody>{rows.length > 0 ? rows : emptyRow}</tbody>
    </table>
  );
}
